import { Observable } from 'rxjs';
import httpService from './httpService';
import { Passenger } from '../data/models/passenger.model';

class PassengerService {
  private readonly apiBase;

  constructor() {
    const { __environment__ } = window as any;
    this.apiBase = __environment__.REACT_APP_PASSENGER_API_URL.trim();
  }

  public getPassenger(passengerUUID: string): Observable<Passenger> {
    let url = `${this.apiBase}/getPassenger?passengerUUID=${passengerUUID}`;
    return httpService.getJSON(url);
  }
}

const passengerService = new PassengerService();

export default passengerService;
